import { render, staticRenderFns } from "./tab-view-images.vue?vue&type=template&id=e43f0e38&"
import script from "./tab-view-images.vue?vue&type=script&lang=js&"
export * from "./tab-view-images.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports